import React from "react";
import PropTypes from "prop-types";
import TabNav from "../common/TabNav";
import TabNavItem from "../common/TabNavItem";
import { GetTopNavItems } from "./NavItemHelper";

const TopNav = ({ topNavTabSettings, scope, accountId, accountType }) => {
	const items = GetTopNavItems(topNavTabSettings, scope, accountId, accountType);
	return (
		<nav>
			<TabNav>
				{items.map((item, i) =>
					<TabNavItem
						key={i}
						display={item.text}
						iconType={item.iconType}
						color={item.color}
						to={item.to}
						disabled={item.disabled}
						visible={item.visible}
						hideText={item.hideText} />
				)}
			</TabNav>
		</nav>
	);
};

TopNav.propTypes = {
	topNavTabSettings: PropTypes.object.isRequired,
	scope: PropTypes.string,
	accountId: PropTypes.string,
	accountType: PropTypes.string
};

export default TopNav;